import { NavLink } from "react-router-dom";
import { dLogout } from "../../http";
import { setAuth } from "../../store/auth-slice";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const Intern = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const logout = async () => {
    await dLogout();
    dispatch(setAuth(null));
    return history.push("/login");
  };

  return (
    <ul className="sidebar-menu">
      <li>
        <NavLink className="nav-link" to="/home">
          <i className="fas fa-fire"></i> <span>Dashboard</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/intern/teams">
          <i className="fas fa-users"></i> <span>Team</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/intern/attendance">
          <i className="fas fa-user"></i> <span>Attendance</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/intern/leave/apply">
          <i className="fas fa-pen"></i> <span>Apply For Leave</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/intern/leave/applications">
          <i className="fas fa-book"></i> <span>Leave Applications</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/intern/salary">
          <i className="fas fa-piggy-bank"></i> <span>Salary</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/intern/payslip">
          <i className="fas fa-file-pdf"></i> <span>Payslip</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/intern/report">
          <i className="fas fa-tasks"></i> <span>Daily Report</span>
        </NavLink>
      </li>

      <li className="menu-header">Settings</li>
      <li>
        <NavLink className="nav-link" to="/intern/contact">
          <i className="fab fa-teamspeak"></i> <span>Contact Us</span>
        </NavLink>
      </li>
      <li>
        <NavLink onClick={logout} className="nav-link" to="/home">
          <i className="fas fa-sign-out-alt"></i> <span>Logout</span>
        </NavLink>
      </li>
    </ul>
  );
};

export default Intern;
